export var ExperienceType = /*#__PURE__*/function (ExperienceType) {
  ExperienceType["UNIFIED_HELP"] = "unified-help";
  return ExperienceType;
}({});